import { BasePaginatedUseCase } from "../../../../../common/domain/useCases/base_paginated_use_case";
import { IGetMotivosAfastamentoUseCase } from "../../../presentation/useCases/read/get_motivos_afastamento_use_case";
import { MotivoAfastamento } from "../../models/motivo_afastamento";
import { IRhRepository } from "../../repositories/rh_repository";

/**
 * IGetMotivosAfastamentoUseCase
 */

export class GetMotivosAfastamentoUseCase extends BasePaginatedUseCase<MotivoAfastamento> implements IGetMotivosAfastamentoUseCase {
  constructor(
    private readonly repository: IRhRepository,
  ) {
    super();
  }

  async getMotivosAfastamento(
    tipoPesquisa: number,
    motivoAfastamento: string,
    status: number,
    page: number,
    pageSize: number,
  ): Promise<void> {
    const response = await this.repository.getMotivosAfastamento(
      tipoPesquisa,
      motivoAfastamento,
      status,
      page,
      pageSize,
    );

    this._items = response.items;
    this._pageSize = response.pageSize;
    this._currentPage = response.currentPage;
    this._totalItems = response.totalItems;
    this._totalPages = response.totalPages;
  }
}